




import {Component, Prop, Vue} from "vue-property-decorator";
import {WardStore} from "@/modules/regionsv2/ward/store";

@Component({
    name: "WardLabelV2"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        return WardStore.data[this.id]?.name;
    }
}
